module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    },
    on: {
      "dragenter": _vm.dragEnter
    }
  }, [_c('div', {
    staticClass: "demo-layout mdl-layout mdl-layout--fixed-drawer mdl-layout--fixed-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50",
    class: {
      'is-visible': _vm.drawerVisible
    },
    attrs: {
      "id": "main-drawer"
    }
  }, [_vm._m(1), _vm._v(" "), _c('LeftMenu')], 1) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content mdl-color--grey-100",
    class: {
      'drawer-is-visible': _vm.drawerVisible && _vm.loggedIn
    }
  }, [(_vm.loggedIn) ? _c('button', {
    staticClass: "drawer-button",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.showDrawer
    }
  }, [(!_vm.drawerVisible) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")]) : _vm._e(), _vm._v(" "), (_vm.drawerVisible) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('router-view')], 1)])]), _vm._v(" "), _c('overlay-component', {
    attrs: {
      "overlayModel": _vm.overlayModel
    }
  }), _vm._v(" "), _c('GlobalDropZone')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-drawer-header"
  }, [_c('img', {
    staticClass: "demo-avatar",
    attrs: {
      "src": "/static/images/voleadstools2_mid.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c95520"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 448
// module chunks = 0